import mergeStyleCls from '@RootCommon/utils/mergeStyleCls' // 此处即为双端样式合并函数
import stylesUnion from './index.union.less' // 此处为双端统一样式引入

const dist = mergeStyleCls({ stylesUnion })

export default dist
